'use client';

import { c as _c } from "react/compiler-runtime";
import { type PushNotificationsPrePromptModalCmsContent } from './push-notifications-pre-prompt-modal';
import { PushNotificationsPrePromptModalLoader } from './push-notifications-pre-prompt-modal-loader';
import { usePushNotificationPrePrompt } from './use-push-notification-pre-prompt';
export const PushNotificationPrePromptClient = t0 => {
  const $ = _c(6);
  const {
    cmsContent
  } = t0;
  const {
    isLoading,
    onAllow,
    onClose,
    shouldShow
  } = usePushNotificationPrePrompt();
  let t1;
  if ($[0] !== cmsContent || $[1] !== isLoading || $[2] !== onAllow || $[3] !== onClose || $[4] !== shouldShow) {
    t1 = <PushNotificationsPrePromptModalLoader cmsContent={cmsContent} isLoading={isLoading} isOpen={shouldShow} onAllow={onAllow} onClose={onClose} />;
    $[0] = cmsContent;
    $[1] = isLoading;
    $[2] = onAllow;
    $[3] = onClose;
    $[4] = shouldShow;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};